module.exports = __webpack_public_path__ + "img/business-solutions-hero-mobile@2x.8811cb32.webp";